import { useRef } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Keyboard, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { fitIn } from "@/utils/imageHandler";

const PreviewSlider = ({ cover, pages }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <div className='relative z-20 w-full mx-4 group lg:mx-0'>
      <button
        ref={prevRef}
        className='absolute left-0 top-1/2 -translate-y-1/2 z-30 duration-200 inline-flex items-center backdrop-blur-md justify-center w-10 h-10 ease-out -translate-x-[calc(100%+12px)] rounded-full bg-white/10 hover:opacity-90 disabled:opacity-50'
      >
        <CaretLeft size={24} weight='bold' color='#ffffff' />
      </button>
      <button
        ref={nextRef}
        className='absolute right-0 z-30 inline-flex items-center justify-center w-10 h-10 mr-3 duration-200 ease-out -translate-y-1/2 rounded-full top-1/2 backdrop-blur-md bg-white/10 hover:opacity-90 disabled:opacity-50'
      >
        <CaretRight size={24} weight='bold' color='#ffffff' />
      </button>
      <Swiper
        modules={[Navigation, Keyboard, Mousewheel]}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        keyboard={true}
        slidesPerView={"auto"}
        mousewheel={{ forceToAxis: true, releaseOnEdges: false }}
        spaceBetween={16}
        className='preview-slider'
      >
        <SwiperSlide className='relative !w-[200px] lg:!w-[250px]'>
          <img src={fitIn(cover, 600)} alt='Slider Item Image' className='relative' />
        </SwiperSlide>
        {pages.map((page, index) => (
          <SwiperSlide key={index} className='!w-[200px] lg:!w-[250px]'>
            <img src={page} alt='Slider Item Image' />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PreviewSlider;
